import { Injectable } from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationEnd } from '@angular/router'
import { GlobalService } from './global.service'
import { LoginService } from '../http/login/login.service'
import { ToastrService } from 'ngx-toastr'
import { passcodeDisabledUserRoles } from 'src/app/shared/models/constants'
import { filter } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    history: string[] = [];
    isAMTPortal = false;
    private previousUrl: string | null = null;
    private currentUrl: string | null = null;

    constructor(private router: Router,
        private location: Location,
        private toastr: ToastrService,
        private loginService: LoginService,
        private global: GlobalService
    ) {
        this.isAMTPortal = this.global.validateIsAMTPortalDomain();

        this.currentUrl = this.router.url;
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.urlAfterRedirects || event.url;
                const isOnEmployeeLoginPage = this.currentUrl === '/login/member';
                const isEmployeeUrl = isOnEmployeeLoginPage ? '1' : '0';
                localStorage.setItem('isEmployeeUrl', isEmployeeUrl);
            });
    }

    public startSaveHistory(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects)
            }
        })
    }

    public clearHistory(): string[] {
        return this.history = [];
    }

    public back(): void {
        if (this.previousUrl && (this.previousUrl.includes('payment-methods/Add') || this.previousUrl.includes('documents') || this.previousUrl.includes('dashboard'))) {
            this.router.navigate(['/dashboard']);
        } else {
            this.location.back();
        }
        return;
    }

    public disable2FA(loginResponse): boolean {
        return loginResponse?.firstLogin || loginResponse?.forcePasswordReset || this.isAMTPortal || passcodeDisabledUserRoles.indexOf(loginResponse?.userRole.toLowerCase()) > -1 || loginResponse?.isEmployeeAdmin;
    }

    /**
     * This function is used to process the passcode verification and navigation.
     * @param {object} loginResponse 
     */
    public processPasscodeNavigation(loginResponse): void {
        const isPasscodeDisabled = this.disable2FA(loginResponse);
        if (isPasscodeDisabled) {
            this.global.user.passcodeVerified = true;
            localStorage.setItem("passcodeVerified", this.global.user.passcodeVerified);
            this.router.navigateByUrl(`/dashboard`);
        } else {
            this.loginService.sendPasscode().subscribe((res: any) => {
                if (res.status) {
                    this.router.navigateByUrl(`/passcode-verification`);
                } else {
                    this.toastr.warning(res.message);
                }
            });
        }
    }

    public getPreviousUrl() {
        return this.previousUrl;
    }

}
